import Game from 'app/records/game'
import React, { PropTypes } from 'react'
import Strings from 'config/strings'
import Team from 'app/records/team'
import { pluralize } from 'lib/strings'

export default React.createClass({

  propTypes: {
    game   : PropTypes.instanceOf(Game).isRequired,
    onNext : PropTypes.func.isRequired
  },

  render() {
    const { game, onNext } = this.props
    const { turn_score } = game

    const current    = Game.getCurrentTeam(game)
    const enemy      = Game.getRivalTeam(game)
    const slot       = Game.getSlot(game)
    const enemy_slot = Game.getRivalSlot(game)

    return (
      <main className="round-starting fill-black">
        <header className="banner">
          Round { game.round } • <span className={ "color-team-" + slot }>Turn { game.turn } end</span>
        </header>

        <form className="container" ref="form" onSubmit={ this.onContinue }>
          <div className="gif-picker__gif gif-picker__gif--short" style={{ backgroundImage: `url(${ Team.getGif(current) })` }} />

          <div className="turn-finished__title">
            Nice Job Ace! You Scored { game.turn_score } { pluralize(game.turn_score, 'card', 'cards') }!
          </div>

          <div className="row">
            <div className="col round-starting__team no-vs fill-blue">
              { game.team_1.name }<br/>
              { game.team_1.score }
            </div>
            <div className="col round-starting__team fill-red">
              { game.team_2.name }<br/>
              { game.team_2.score }
            </div>
          </div>

          <div className={ "turn-finished__next-up fill-team-flat-" + enemy_slot }>
            { game.cards_left } cards left • Next Up: Team { enemy.name }
          </div>

          <input className="round-starting__submit" type="submit" value={ Strings['turn.finished.advance'] } />
        </form>
      </main>
    )
  },

  onContinue(e) {
    e.preventDefault()
    this.props.onNext()
  }

})



/** WEBPACK FOOTER **
 ** ./web/static/app/components/game/phases/turn-finished.jsx
 **/